import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeWarningLocaleModule: LocaleModule = {
  name: "employeeWarning",
  messages: { en: en, it: it },
};
